import resolveRequest from '../../utils/resolveRequest.js'
import axios from 'axios'
import { apiEndpoints, SERVER_PATH } from '../endpoints'

export default async (contactId) => {
  const endpoint = `${apiEndpoints.contacts}/${contactId}`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.delete(URL, { withCredentials: true }))
}
